/* mm-sliderschrift.js — eine Schrift für den Sternify-Kollektionsslider.
 *
 * 23.08.2026, Mert mit zwei Bildern: "diese schriftart überall in dieser
 * section / alles muss gleich sein, gerade ist fehlerhaft".
 *
 * GEMESSEN: Der Baustein `st_collection_slider` bringt sein eigenes @font-face
 * mit und setzt darin "Poppins" in Gewicht 400 — auch für Überschriften und
 * Knöpfe. Daneben stehen Reste in "DM Sans". Dadurch sah in einer einzigen
 * Sektion jede Zeile anders aus: dünne Überschrift, andere Laufweite, andere
 * Grundlinie.
 *
 * Hier wird deshalb für die ganze Sektion eine Familie festgelegt — "MM Poppins",
 * die der Shop ohnehin lädt (Design-Grundregel 3: höchstens zwei bis drei
 * Schriften). Die Gewichte werden nach Rolle vergeben: Überschrift schwer,
 * Fließtext normal, Knöpfe halbfett. Nichts wird ausgetauscht oder entfernt,
 * nur die Schrift vereinheitlicht.
 */
(function () {
  'use strict';

  var WAHL = '[id*="st_collection_slider"]';

  var css = [
    /* Eine Familie für alles in dieser Sektion. */
    'SEK, SEK *{font-family:"MM Poppins","DM Sans",sans-serif!important}',

    /* Rollen statt Zufall: Überschrift schwer und eng, Text normal,
       Knöpfe halbfett. So sitzt jede Zeile auf derselben Linie. */
    'SEK h1,SEK h2,SEK .st_title,SEK [class*="title"]{font-weight:800!important;',
    'letter-spacing:-.01em!important;line-height:1.08!important}',
    'SEK h3,SEK h4{font-weight:600!important;letter-spacing:0!important}',
    /* 29.08.2026, Mert: "duenner und kleiner" zum Untertitel ueber den
       Neuheiten. GEMESSEN: Die Klasse heisst `...-title-subtitle` und wurde
       deshalb schon von `[class*="title"]` (800) erfasst und hier auf 600
       gesetzt - eine Einstellung in der Sektion konnte dagegen nichts
       ausrichten. Unter-/Bildzeilen stehen jetzt auf 400 und tragen mehr
       Zeilenluft; Ueberschriften bleiben unveraendert. */
    'SEK [class*="subtitle"],SEK [class*="caption"]{',
    'font-weight:400!important;letter-spacing:0!important;line-height:1.35!important}',
    /* 25.08.2026, Mert: "diese unterschrift texte duenner machen" - gezeigt
       war der Beschreibungstext unter der Ueberschrift ("... als die
       (Standard Version) mit super leckerem Pistazien-Nuss Geschmack").
       Er stand in 400 und wirkte neben der 800er Ueberschrift schwer.
       300 nimmt Gewicht heraus, bleibt auf dem dunklen Foto aber lesbar. */
    'SEK p,SEK span,SEK li,SEK div{font-weight:300!important;',
    'letter-spacing:0!important}',
    'SEK a[class*="button"],SEK button,SEK .st_button,SEK [class*="btn"]{',
    'font-weight:700!important;letter-spacing:.01em!important}',
    /* Die Überschrift stand in Grossbuchstaben, der Rest gemischt - das ist der
       zweite Grund, warum es unruhig wirkte. Grossbuchstaben nur oben. */
    'SEK p,SEK span:not([class*="title"]){text-transform:none!important}',
    /* 23.08.2026, Mert: "ich will diese schriftart wie im 1. bild" - gezeigt
       war das Abzeichen "NEW" in der fetten Grotesk. Abzeichen sind klein,
       fallen also nicht unter die Groessenregel unten; sie bekommen das
       Gewicht deshalb ausdruecklich. */
    'SEK [class*="badge"],SEK [class*="badge"] *{font-weight:800!important;',
    'letter-spacing:.02em!important;text-transform:uppercase!important}',
    'SEK .mmSchWer{font-weight:800!important;letter-spacing:-.01em!important}',
    'SEK .mmSchHalb{font-weight:700!important}'
  ].join('');

  function stil(id) {
    if (document.getElementById('mm-sliderschrift-stil')) return;
    var s = document.createElement('style');
    s.id = 'mm-sliderschrift-stil';
    s.textContent = css.replace(/SEK/g, '#' + id);
    (document.head || document.documentElement).appendChild(s);
  }

  /* GEMESSEN: Die Ueberschrift der App steckt in einem <span>, nicht in einem
     <h2> - eine Regel nach Tag greift dort nicht, und die Zeile blieb bei 44 px
     duenn stehen. Deshalb wird nach der gerenderten Groesse entschieden: alles
     ab 26 px ist eine Ueberschrift und wird schwer gesetzt. */
  function gewichten(sek) {
    var alle = sek.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) {
      var e = alle[i];
      if (e.children.length) continue;
      if (!(e.textContent || '').trim()) continue;
      var c = getComputedStyle(e);
      var gr = parseFloat(c.fontSize) || 0;
      if (gr >= 26) e.classList.add('mmSchWer');
      else if (/button|btn/i.test(e.className || '') ||
               (e.parentElement && /button|btn/i.test(e.parentElement.className || ''))) {
        e.classList.add('mmSchHalb');
      }
    }
  }

  function bauen() {
    var sek = document.querySelector(WAHL);
    if (!sek || !sek.id) return false;
    stil(sek.id);
    gewichten(sek);
    /* Die App tauscht ihre Folien nach; deshalb noch ein paar Mal nachziehen. */
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      gewichten(sek);
      if (n > 8) window.clearInterval(t);
    }, 900);
    return true;
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 30) window.clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
})();
